(function () {
  var container = document.getElementById('perso-container');
  if (!container) return;

  var cfg = window.__perso_config || {};
  var API_URL  = 'https://samourai-api-seven.vercel.app/api/generate';
  var VARIANT_ID = cfg.VARIANT_ID || 0;
  var SIZE_VARIANTS = { 'S': 52530405474632, 'M': 52530405507400, 'L': 52530405540168, 'XL': 52530405572936, '2XL': 52530405605704, '3XL': 52530405638472 };
  var DIGITAL_VARIANT_ID = cfg.DIGITAL_VARIANT_ID || 0;
  var LOADING_GIF_URL = cfg.LOADING_GIF_URL || '';
  var BREVO_API_KEY = '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';
  var BREVO_LIST_ID = 3;
  var DAILY_TOKEN = cfg.DAILY_TOKEN || '';
  var CLOUDINARY_CLOUD = 'dvtyqvo5c';
  var CLOUDINARY_PRESET = 'npp-uploads';
  var uploadPending = 0;
  var previewGenerated = false;
  var blockCount = 0;

  var COLOR_HEX = {
    'Bordeaux':      '#95352d',
    'Turquoise':     '#1b949a',
    'Mauve':         '#a689c9',
    'Bleu marine':   '#254b85',
    'Jaune':         '#eeb54f',
    'Vert':          '#00674F',
    'Rose':          '#cd8a92',
    'Orange':        '#e58f46',
    'Noir (Ninja)':  '#1a1a1a'
  };

  var colors = [
    { name: 'Bordeaux',     hex: '#722F37' },
    { name: 'Turquoise',    hex: '#2ABFBF' },
    { name: 'Mauve',        hex: '#9B6BB5' },
    { name: 'Bleu marine',  hex: '#1B2A6B' },
    { name: 'Jaune',        hex: '#F5C518' },
    { name: 'Vert',         hex: '#00674F' },
    { name: 'Rose',         hex: '#E87DA8' },
    { name: 'Orange',       hex: '#F07B2F' },
    { name: 'Noir (Ninja)', hex: '#1a1a1a' }
  ];

  var uploadIcon = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#d1817e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>';

  function getAtcBtn() {
    return document.getElementById('custom-atc-btn')
      || document.querySelector('button[name="add"]')
      || document.querySelector('.product-form__submit')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]');
  }

  function hideAtc() {
    var btn = getAtcBtn();
    if (btn) btn.style.display = 'none';
  }

  function showAtc() {
    var btn = getAtcBtn();
    if (btn) {
      btn.style.display = '';
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
    var steps = document.getElementById('atc-steps');
    if (steps) steps.style.display = '';
  }

  function setAtcBlocked(blocked) {
    if (previewGenerated) return;
    var btn = getAtcBtn();
    if (!btn) return;
    btn.disabled = blocked;
    btn.style.opacity = blocked ? '0.55' : '';
    btn.style.cursor = blocked ? 'not-allowed' : '';
  }

  function createBlock(index, total) {
    if (!document.getElementById('perso-carousel-css')) {
      var _cs = document.createElement('style');
      _cs.id = 'perso-carousel-css';
      _cs.textContent = '.perso__carousel{position:relative;overflow:hidden}.perso__carousel-track{display:flex;transition:transform 0.35s ease}.perso__carousel-slide{flex:0 0 100%;text-align:center}.perso__slide-label{font-size:0.78rem;color:#999;margin:5px 0 0}.perso__carousel-nav{display:flex;align-items:center;justify-content:center;gap:12px;margin-top:10px}.perso__dot{width:10px;height:10px;border-radius:50%;background:#ddd;cursor:pointer;transition:background .2s;display:inline-block;flex-shrink:0}.perso__dot--active{background:#d1817e}.perso__carousel-btn{display:inline-flex;align-items:center;gap:6px;background:#d1817e;color:#fff;border:none;border-radius:20px;padding:7px 16px;font-size:0.82rem;font-weight:700;cursor:pointer;white-space:nowrap;transition:opacity .2s}.perso__carousel-btn:hover{opacity:0.85}.perso__carousel-btn svg{flex-shrink:0}';
      document.head.appendChild(_cs);
    }
    var n = index + 1;
    var propBase = 'T-shirt ' + n;
    var div = document.createElement('div');
    div.className = 'perso';

    var colorsHtml = colors.map(function(c) {
      return '<label class="perso__color-option">'
        + '<input type="radio" name="properties[' + propBase + ' - Kimono color]" value="' + c.name + '">'
        + '<span class="perso__color-swatch"><span class="perso__color-dot" style="background:' + c.hex + '"></span>' + c.name + '</span>'
        + '</label>';
    }).join('');

    div.innerHTML = '<p class="perso__eyebrow">Design t-shirt n°' + n + '</p>'
      + (n > 1 ? '<button type="button" class="perso__block-remove" id="blockdel-' + n + '" title="Supprimer ce bloc">'
          + '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>'
          + '</button>' : '')

      + ''

      + '<div class="perso__form-section" id="perso-form-' + n + '">'

        + '<div class="perso__field">'
          + '<span class="perso__field-label">Taille</span>'
          + '<div class="perso__sizes">'
          + ['S','M','L','XL','2XL','3XL'].map(function(s, i) {
              return '<label class="perso__size-option">'
                + '<input type="radio" name="properties[' + propBase + ' - Size]" value="' + s + '"' + (i === 0 ? ' checked' : '') + '>'
                + '<span class="perso__size-swatch">' + s + '</span>'
                + '</label>';
            }).join('')
          + '</div>'
        + '</div>'

        + '<div class="perso__upload-zone" id="pz-' + n + '">'
          + '<input type="file" accept="image/*" id="pf-' + n + '" style="display:none">'
          + '<div id="pp-' + n + '" class="perso__placeholder">' + uploadIcon + '<p class="perso__upload-label">Dépose une photo</p><span class="perso__upload-hint">JPG, PNG — max 10 Mo</span></div>'
          + '<div id="pw-' + n + '" class="perso__preview-wrap" hidden>'
            + '<img id="pi-' + n + '" class="perso__preview-img" src="" alt="">'
            + '<div class="perso__preview-actions">'
              + '<button type="button" id="pc-' + n + '" class="perso__change-btn">Changer</button>'
              + '<button type="button" id="pd-' + n + '" class="perso__delete-btn">✕</button>'
            + '</div>'
          + '</div>'
        + '</div>'
        + '<div id="ps-' + n + '" class="perso__upload-status" hidden></div>'
        + '<input type="hidden" name="properties[' + propBase + ' - Photo]" id="pv-' + n + '" value="">'

        + '<div class="perso__field">'
          + '<label class="perso__field-label" for="pn-' + n + '">Prénom de ton animal</label>'
          + '<input type="text" id="pn-' + n + '" name="properties[' + propBase + ' - Name]" class="perso__name-input" placeholder="Ex : Luna, Max, Milo…" maxlength="30">'
        + '</div>'

        + '<details class="perso__accordion" id="acc-' + n + '">'
          + '<summary class="perso__accordion-summary">'
            + '<span class="perso__field-label">Couleur du kimono</span>'
            + '<span class="perso__accordion-preview perso__accordion-preview--placeholder" id="acc-preview-' + n + '">Choisir</span>'
            + '<svg class="perso__accordion-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>'
          + '</summary>'
          + '<div class="perso__colors">' + colorsHtml + '</div>'
        + '</details>'

      + '</div>'

      + '<div class="perso__gen">'
        + '<button type="button" class="perso__gen-btn" id="genbtn-' + n + '">✨ Voir mon aperçu</button>'
        + '<div class="perso__gen-loading" id="genloading-' + n + '" style="display:none">'
          + '<span class="perso__gen-sword"><img src="' + LOADING_GIF_URL + '" alt="" width="80" height="80" style="border-radius:8px;"></span>'
          + '<p class="perso__gen-step" id="genstep-' + n + '">📸 Analyzing your pet...</p>'
          + '<div class="perso__gen-bar"><div class="perso__gen-progress" id="genprogress-' + n + '"></div></div>'
          + '<p class="perso__gen-hint">30 à 60 secondes</p>'
        + '</div>'
        + '<p class="perso__gen-error" id="generror-' + n + '"></p>'
      + '</div>'

      + '<div class="perso__gen-result" id="genresult-' + n + '" style="display:none">'
        + '<button type="button" class="perso__gen-delete" id="gendel-' + n + '" title="Delete this design">'
          + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>'
        + '</button>'
        + '<div class="perso__gen-timer">Votre création expire dans <span id="gencount-' + n + '">3h00</span></div>'
        + '<div class="perso__carousel" id="carousel-' + n + '">'
          + '<div class="perso__carousel-track" id="cartrack-' + n + '">'
            + '<div class="perso__carousel-slide"><canvas id="gencanvas-' + n + '" class="perso__gen-canvas"></canvas><p class="perso__slide-label"></p></div>'
            + '<div class="perso__carousel-slide"><canvas id="mockcanvas-' + n + '" class="perso__gen-canvas"></canvas><p class="perso__slide-label">Voir le rendu sur t-shirt</p></div>'
          + '</div>'
        + '</div>'
        + '<p class="perso__gen-note">Ce design sera imprimé sur ton t-shirt, sans filigrane et en HD</p>'
        + '<button type="button" class="perso__block-atc" id="blockatc-' + n + '">'
          + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'
          + 'Ajouter mon t-shirt au panier'
        + '</button>'
        + '<div class="perso__payment-logos"><img src="https://res.cloudinary.com/dvtyqvo5c/image/upload/v1788295167/kbr5xjavv7xwl7ekejsz.png" alt="Visa PayPal Mastercard Apple Pay Google Pay"></div>'
      + '</div>'

      + '<input type="hidden" name="properties[T-shirt ' + n + ' - Preview]" id="genurl-' + n + '" value="">';

    if (n > 1) {
      var blockRemoveBtn = div.querySelector('#blockdel-' + n);
      if (blockRemoveBtn) {
        blockRemoveBtn.addEventListener('click', function() {
          div.remove();
          blockCount = blockCount - 1;
          updateAddBtn();
        });
      }
    }

    bindUpload(div, n);
    return div;
  }

  function bindUpload(div, n) {
    var zone        = div.querySelector('#pz-' + n);
    var file        = div.querySelector('#pf-' + n);
    var placeholder = div.querySelector('#pp-' + n);
    var previewWrap = div.querySelector('#pw-' + n);
    var previewImg  = div.querySelector('#pi-' + n);
    var photoVal    = div.querySelector('#pv-' + n);
    var changeBtn   = div.querySelector('#pc-' + n);
    var deleteBtn   = div.querySelector('#pd-' + n);
    var statusEl    = div.querySelector('#ps-' + n);

    function setStatus(state, msg) {
      statusEl.hidden = !msg;
      statusEl.textContent = msg || '';
      statusEl.className = 'perso__upload-status' + (state ? ' perso__upload-status--' + state : '');
    }

    function resetPhoto() {
      photoVal.value = '';
      previewImg.src = '';
      file.value = '';
      previewWrap.hidden = true;
      placeholder.hidden = false;
      setStatus('', '');
      changeBtn.textContent = 'Change';
      try { localStorage.removeItem('perso_photo_' + n); } catch(e) {}
    }

    function uploadDone() {
      uploadPending = Math.max(0, uploadPending - 1);
      if (uploadPending === 0) setAtcBlocked(false);
    }

    zone.addEventListener('click', function(e) {
      if (e.target !== changeBtn && e.target !== deleteBtn) file.click();
    });
    changeBtn.addEventListener('click', function(e) { e.stopPropagation(); file.click(); });
    deleteBtn.addEventListener('click', function(e) { e.stopPropagation(); resetPhoto(); });
    statusEl.addEventListener('click', function() {
      if (statusEl.classList.contains('perso__upload-status--error')) file.click();
    });

    file.addEventListener('change', function() {
      var f = this.files[0];
      if (!f) return;
      var reader = new FileReader();
      reader.onload = function(ev) {
        var img = new Image();
        img.onload = function() {
          var canvas = document.createElement('canvas');
          var MAX = 800, ratio = Math.min(MAX / img.width, MAX / img.height, 1);
          canvas.width  = Math.round(img.width  * ratio);
          canvas.height = Math.round(img.height * ratio);
          canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
          var dataUrl = canvas.toDataURL('image/jpeg', 0.7);
          var base64  = dataUrl.split(',')[1];

          previewImg.src = dataUrl;
          placeholder.hidden = true;
          previewWrap.hidden = false;
          photoVal.value = '';
          try { localStorage.setItem('perso_photo_' + n, dataUrl); } catch(e) {}

          uploadPending++;
          setAtcBlocked(true);
          changeBtn.textContent = '⏳ Envoi…';
          setStatus('loading', 'Envoi de la photo…');

          var byteStr = atob(base64);
          var ab = new ArrayBuffer(byteStr.length);
          var ia = new Uint8Array(ab);
          for (var i = 0; i < byteStr.length; i++) ia[i] = byteStr.charCodeAt(i);
          var photoBlob = new Blob([ab], { type: 'image/jpeg' });

          var fd = new FormData();
          fd.append('upload_preset', CLOUDINARY_PRESET);
          fd.append('file', photoBlob, 'photo.jpg');

          fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', { method: 'POST', body: fd })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data && data.secure_url) {
                photoVal.value = data.secure_url;
                changeBtn.textContent = 'Change';
                setStatus('ok', '✓ Photo envoyée');
                uploadDone();
              } else { throw new Error('upload failed'); }
            })
            .catch(function() {
              file.value = '';
              changeBtn.textContent = 'Change';
              setStatus('error', '✗ Erreur d\'envoi — cliquer pour réessayer');
              uploadDone();
            });
        };
        img.src = ev.target.result;
      };
      reader.readAsDataURL(f);
    });
  }

  function bindAccordion(div, n) {
    var preview = div.querySelector('#acc-preview-' + n);
    div.querySelectorAll('.perso__color-option input[type="radio"]').forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (preview) {
          preview.textContent = this.value;
          preview.classList.remove('perso__accordion-preview--placeholder');
          var chosen = colors.find(function(c) { return c.name === radio.value; });
          preview.style.color = chosen ? chosen.hex : '#d1817e';
        }
        var acc = div.querySelector('#acc-' + n);
        if (acc) acc.removeAttribute('open');
      });
    });
  }

  function drawMockupFromCanvas(source, destCanvas, cb) {
    var sourceImg = new Image();
    sourceImg.onload = function() {
      var mockup = new Image();
      mockup.crossOrigin = 'anonymous';
      mockup.onload = function() {
        var mw = mockup.naturalWidth, mh = mockup.naturalHeight;
        destCanvas.width = mw; destCanvas.height = mh;
        var ctx = destCanvas.getContext('2d');
        ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, mw, mh);
        ctx.drawImage(mockup, 0, 0, mw, mh);
        var px = Math.round(mw * PRINT_X), py = Math.round(mh * PRINT_Y);
        var pw = Math.round(mw * PRINT_W), ph = Math.round(mh * PRINT_H);
        var fitScale = Math.min(pw / sourceImg.width, ph / sourceImg.height) * 1.0;
        var fw2 = Math.round(sourceImg.width * fitScale), fh2 = Math.round(sourceImg.height * fitScale);
        var fx = px + Math.round((pw - fw2) / 2), fy = py + Math.round((ph - fh2) / 2);
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(sourceImg, fx, fy, fw2, fh2);
        ctx.globalCompositeOperation = 'source-over';
        var fil = new Image();
        fil.crossOrigin = 'anonymous';
        fil.onload = function() { ctx.globalAlpha = 0.7; ctx.drawImage(fil, 0, 0, mw, mh); ctx.globalAlpha = 1; if (cb) cb(); };
        fil.onerror = function() { if (cb) cb(); };
        fil.src = FILIGRANE_URL + (FILIGRANE_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
      };
      mockup.onerror = function() { if (cb) cb(); };
      mockup.src = MOCKUP_URL + (MOCKUP_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
    };
    sourceImg.src = typeof source === 'string' ? source : source.toDataURL();
  }

  function bindPreview(div, n) {
    var genBtn     = div.querySelector('#genbtn-' + n);
    var loadingEl  = div.querySelector('#genloading-' + n);
    var stepEl     = div.querySelector('#genstep-' + n);
    var progressEl = div.querySelector('#genprogress-' + n);
    var resultEl   = div.querySelector('#genresult-' + n);
    var canvas     = div.querySelector('#gencanvas-' + n);
    var mockCanvas = div.querySelector('#mockcanvas-' + n);
    var mockBtn    = div.querySelector('#mockbtn-' + n);
    var dot1       = div.querySelector('#dot1-' + n);
    var dot2       = div.querySelector('#dot2-' + n);
    var lastImageBase64 = null;
    var mockDrawn = false;
    var onSlide2 = false;
    function goToSlide(idx) {
      var track = div.querySelector('#cartrack-' + n);
      if (track) track.style.transform = idx === 1 ? 'translateX(-100%)' : 'translateX(0)';
      onSlide2 = idx === 1;
      if (dot1) dot1.classList.toggle('perso__dot--active', idx === 0);
      if (dot2) dot2.classList.toggle('perso__dot--active', idx === 1);
    }
    function saveMockThumbnail() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY + '_' + n);
        var stored = raw ? JSON.parse(raw) : {};
        stored.previewUrl = mockCanvas.toDataURL('image/jpeg', 0.85);
        localStorage.setItem(STORAGE_KEY + '_' + n, JSON.stringify(stored));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch(e) {}
    }
    if (mockBtn && mockCanvas) {
      mockBtn.addEventListener('click', function() {
        if (onSlide2) { goToSlide(0); return; }
        if (mockDrawn) { goToSlide(1); return; }
        var src = lastImageBase64 ? 'data:image/png;base64,' + lastImageBase64 : canvas;
        drawMockupFromCanvas(src, mockCanvas, function() {
          mockDrawn = true;
          goToSlide(1);
          saveMockThumbnail();
        });
      });
    }
    var errorEl    = div.querySelector('#generror-' + n);

    var STEPS = ['📸 Analyse de ton animal...', '🎨 Création de l\'illustration...', '✨ Ajout des détails samouraï...', '🏯 Retouches finales...'];

    function doGenerate() {
      resultEl.querySelectorAll('[style]').forEach(function(el) { el.style.display = ''; });
      if (localStorage.getItem(STORAGE_KEY + '_' + n)) {
        if (!confirm('⚠️ Un aperçu est déjà enregistré. Le remplacer supprimera définitivement le design actuel. Continuer ?')) return;
      }

      var previewImg = div.querySelector('#pi-' + n);
      var nameInput  = div.querySelector('#pn-' + n);
      var colorInput = div.querySelector('.perso__color-option input[type="radio"]:checked');
      var uploadZone = div.querySelector('#pz-' + n);
      var photoVal   = div.querySelector('#pv-' + n);

      div.querySelectorAll('.perso__field--error').forEach(function(el) { el.classList.remove('perso__field--error'); });
      errorEl.style.display = 'none';

      var valid = true;

      if (!photoVal || !photoVal.value) {
        if (uploadZone) uploadZone.classList.add('perso__field--error');
        valid = false;
      }

      if (!nameInput || !nameInput.value.trim()) {
        if (nameInput) nameInput.classList.add('perso__field--error');
        valid = false;
      }

      if (!colorInput) {
        var acc = div.querySelector('#acc-' + n);
        if (acc) acc.setAttribute('open', '');
        valid = false;
      }

      if (!valid) {
        errorEl.textContent = '⚠️ Merci de remplir tous les champs avant de continuer.';
        errorEl.style.display = 'block';
        return;
      }

      var petName     = nameInput ? nameInput.value.trim() : '';
      var base64      = previewImg.src.split(',')[1];
      var color       = colorInput.value;

      errorEl.style.display = 'none';
      resultEl.style.display = 'none';
      genBtn.style.display   = 'none';
      loadingEl.style.display = 'block';
      var formSectionGen = document.getElementById('perso-form-' + n);
      if (formSectionGen) formSectionGen.style.display = 'none';
      setTimeout(function() { loadingEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 50);
      progressEl.style.transition = 'none';
      progressEl.style.width = '0%';

      var stepIndex = 0;
      stepEl.textContent = STEPS[0];
      var stepInterval = setInterval(function() {
        stepIndex = Math.min(stepIndex + 1, STEPS.length - 1);
        stepEl.textContent = STEPS[stepIndex];
      }, 13000);

      setTimeout(function() {
        progressEl.style.transition = 'width 90s ease-out';
        progressEl.style.width = '97%';
      }, 200);

      fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: base64, color: color, petName: petName, token: DAILY_TOKEN })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.error) throw new Error(data.error);
        clearInterval(stepInterval);
        progressEl.style.transition = 'width 0.3s ease';
        progressEl.style.width = '100%';

        setTimeout(function() {
          loadingEl.style.display = 'none';
          drawResult(canvas, data.image, petName, data.japaneseName, color, function() {
            resultEl.style.display = 'block';
            previewGenerated = true;
            finishBlock(n);
            var addBtnScroll = document.getElementById('perso-add-btn');
            (addBtnScroll || resultEl).scrollIntoView({ behavior: 'smooth', block: 'end' });
            lastImageBase64 = data.image;
            uploadPreviewToImgbb(data.image, petName, data.japaneseName, color, n);
            try { var dataUrl = canvas.toDataURL('image/jpeg', 0.85); saveDesign(dataUrl, petName, data.japaneseName, color, n, canvas._cleanDataUrl || null); } catch(e) {}
            generateMockupThumbnail(data.image, petName, data.japaneseName, color, n);
            var saved = loadSavedDesign(n);
            if (saved) startTimer(saved.expiry, n);
            activateMysteryOffer(n);
          });
        }, 350);
      })
      .catch(function(err) {
        clearInterval(stepInterval);
        loadingEl.style.display = 'none';
        genBtn.style.display    = 'block';
        if (formSectionGen) formSectionGen.style.display = '';
        errorEl.textContent     = '❌ ' + (err.message || 'Une erreur est survenue. Veuillez réessayer.');
        errorEl.style.display   = 'block';
      });
    }

    genBtn.addEventListener('click', doGenerate);

    var nameInp = div.querySelector('#pn-' + n);
    if (nameInp) nameInp.addEventListener('input', function() { this.classList.remove('perso__field--error'); });
    var fileInp = div.querySelector('#pf-' + n);
    var uploadZ = div.querySelector('#pz-' + n);
    if (fileInp && uploadZ) fileInp.addEventListener('change', function() { uploadZ.classList.remove('perso__field--error'); });

    var delBtn = div.querySelector('#gendel-' + n);
    if (delBtn) {
      delBtn.addEventListener('click', function() {
        if (!confirm('Ce design sera définitivement supprimé. Es-tu sûr(e) ?')) return;
        localStorage.removeItem(STORAGE_KEY + '_' + n);
        if (timerIntervals[n]) { clearInterval(timerIntervals[n]); delete timerIntervals[n]; }
        deactivateMysteryOffer(n);
        var barDel = document.getElementById('perso-bar-' + n);
        if (barDel) barDel.style.display = 'none';
        resultEl.style.display = 'none';
        genBtn.style.display   = 'block';
        var formSection = document.getElementById('perso-form-' + n);
        if (formSection) formSection.style.display = '';
        var blockDel = document.getElementById('blockdel-' + n);
        if (blockDel) blockDel.style.display = '';
        if (n === 1) {
          var topAlert = document.getElementById('npp-top-alert');
          if (topAlert) topAlert.remove();
          previewGenerated = false;
          hideAtc();
        }
        updateAddBtn();
      });
    }

    var CART_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> ';
    var TSHIRT_ATC_HTML  = CART_ICON_SVG + 'Ajouter mon t-shirt au panier';

    var blockAtcBtn = div.querySelector('#blockatc-' + n);
    if (blockAtcBtn) {
      blockAtcBtn.addEventListener('click', function() {
        var nameInput   = document.getElementById('pn-' + n);
        var photoInput  = document.getElementById('pv-' + n);
        var urlInput    = document.getElementById('genurl-' + n);
        var colorRadio  = div.querySelector('input[name="properties[T-shirt ' + n + ' - Kimono color]"]:checked');
        var tailleRadio = div.querySelector('input[name="properties[T-shirt ' + n + ' - Size]"]:checked');
        var props = {};
        if (nameInput  && nameInput.value)  props['T-shirt 1 - Name']          = nameInput.value;
        if (photoInput && photoInput.value)  props['T-shirt 1 - Photo']         = photoInput.value;
        if (colorRadio)                      props['T-shirt 1 - Kimono color']  = colorRadio.value;
        if (tailleRadio)                     props['T-shirt 1 - Size']          = tailleRadio.value;
        if (urlInput   && urlInput.value)    props['T-shirt 1 - Preview']       = urlInput.value;
        props['_design'] = String(n);
        props['_uid'] = Date.now() + '_' + Math.random().toString(36).slice(2, 7);

        blockAtcBtn.disabled = true;
        blockAtcBtn.innerHTML = '⏳ Ajout au panier...';

        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

        var selectedSize  = tailleRadio ? tailleRadio.value : 'S';
        var baseVariantId = SIZE_VARIANTS[selectedSize] || VARIANT_ID;
        var imageUrl      = urlInput && urlInput.value ? urlInput.value : '';

        function doCartAdd(cartVariantId) {
          fetch(Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: cartVariantId, quantity: 1, properties: props, sections: sectionsToBundle.join(','), sections_url: Shopify.routes.root + 'variants/' + baseVariantId })
          })
          .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, data: d }; }); })
          .then(function(result) {
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
            if (result.ok) {
              blockAtcBtn.innerHTML = '✓ Ajouté !';
              blockAtcBtn.style.background = '#4caf50';
              setTimeout(function() { blockAtcBtn.disabled = false; blockAtcBtn.innerHTML = TSHIRT_ATC_HTML; blockAtcBtn.style.background = ''; }, 2500);
              fetch(Shopify.routes.root + 'cart.js')
                .then(function(r) { return r.json(); })
                .then(function(cartContent) {
                  cartContent['sections'] = result.data['sections'] || {};
                  document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
                  setTimeout(function() { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }, 2000);
                });
            } else {
              blockAtcBtn.disabled = false;
              blockAtcBtn.innerHTML = TSHIRT_ATC_HTML;
            }
          })
          .catch(function() {
            document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
            blockAtcBtn.disabled = false;
            blockAtcBtn.innerHTML = TSHIRT_ATC_HTML;
          });
        }

        doCartAdd(baseVariantId);
      });
    }

  }

  var USE_MOCKUP = false;
  var MOCKUP_URL = 'https://res.cloudinary.com/dvtyqvo5c/image/upload/v1788300101/Nos_Petites_Pattes_4_k6bx6l.png';
  var PLATFORM_URL = 'https://res.cloudinary.com/dvtyqvo5c/image/upload/v1788296630/vqsfk995185knjh9hhu4.png';
  var FILIGRANE_URL = 'https://res.cloudinary.com/dvtyqvo5c/image/upload/v1788297099/Nos_Petites_Pattes_2_sj85ux.png';
  var NOUVEAU_FOND_URL = cfg.NOUVEAU_FOND_URL || '';
  var PRINT_X = 0.32;
  var PRINT_Y = 0.15;
  var PRINT_W = 0.40;
  var PRINT_H = 0.48;
  var PRINT_SCALE = 0.93;
  var PLATFORM_TARGET = 0.85;

  function removeWhite(img) {
    var tmp = document.createElement('canvas');
    tmp.width = img.width; tmp.height = img.height;
    var tctx = tmp.getContext('2d');
    tctx.drawImage(img, 0, 0);
    var id = tctx.getImageData(0, 0, tmp.width, tmp.height);
    var d = id.data;
    var w = tmp.width, h = tmp.height;
    var THRESH = 232;
    var visited = new Uint8Array(w * h);
    var queue = [];
    var head = 0;

    function enqueue(x, y) {
      var pos = y * w + x;
      if (visited[pos]) return;
      var idx = pos * 4;
      if (Math.min(d[idx], d[idx+1], d[idx+2]) < THRESH) return;
      visited[pos] = 1;
      queue.push(pos);
    }

    for (var x = 0; x < w; x++) { enqueue(x, 0); enqueue(x, h-1); }
    for (var y = 1; y < h-1; y++) { enqueue(0, y); enqueue(w-1, y); }

    while (head < queue.length) {
      var pos = queue[head++];
      var px = pos % w, py = (pos / w) | 0;
      if (px > 0)   enqueue(px-1, py);
      if (px < w-1) enqueue(px+1, py);
      if (py > 0)   enqueue(px, py-1);
      if (py < h-1) enqueue(px, py+1);
    }

    var lo = 230, hi = 252;
    for (var i = 0; i < w * h; i++) {
      if (!visited[i]) continue;
      var idx = i * 4;
      var mn = Math.min(d[idx], d[idx+1], d[idx+2]);
      if (mn >= hi) {
        d[idx+3] = 0;
      } else if (mn >= lo) {
        d[idx+3] = Math.round(d[idx+3] * (hi - mn) / (hi - lo));
      }
    }

    tctx.putImageData(id, 0, 0);
    return tmp;
  }

  function getFeetY(dewhitenedCanvas) {
    var tctx = dewhitenedCanvas.getContext('2d');
    var d = tctx.getImageData(0, 0, dewhitenedCanvas.width, dewhitenedCanvas.height).data;
    var maxY = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i+3] > 10) {
        var y = Math.floor((i / 4) / dewhitenedCanvas.width);
        if (y > maxY) maxY = y;
      }
    }
    return maxY;
  }

  function getAnimalOffset(dewhitenedCanvas, imgHeight, padTop) {
    var feetY = getFeetY(dewhitenedCanvas);
    var targetY = Math.round(imgHeight * PLATFORM_TARGET);
    var offset = padTop + targetY - feetY;
    return Math.max(padTop, offset);
  }

  function drawResult(canvas, imageBase64, petName, japaneseName, color, onDone) {
    var img = new Image();
    img.onload = function() {
      var hasText = petName && petName.length > 0;
      var dewhitened = removeWhite(img);

      if (!USE_MOCKUP) {
        canvas.style.marginTop = '0';
        var fondImg = new Image();
        fondImg.crossOrigin = 'anonymous';
        fondImg.onload = function() {
          var MAX_SIZE = 800;
          var iw = img.naturalWidth || 1024;
          var ih = img.naturalHeight || 1024;
          var s = Math.min(MAX_SIZE / iw, MAX_SIZE / ih, 1);
          var fw = Math.round(iw * s);
          var fh = Math.round(ih * s);
          var textPad = hasText ? Math.round(fw * 0.14) : 0;
          canvas.width  = fw;
          canvas.height = fh + textPad;
          var ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, fw, canvas.height);
          ctx.drawImage(img, 0, Math.round(textPad * 0.5), fw, fh);

          function drawFiligraneRaw(cb) {
            var fil = new Image();
            fil.crossOrigin = 'anonymous';
            fil.onload = function() { ctx.globalAlpha = 0.7; ctx.drawImage(fil, 0, 0, fw, canvas.height); ctx.globalAlpha = 1; if (cb) cb(); };
            fil.onerror = function() { if (cb) cb(); };
            fil.src = FILIGRANE_URL + (FILIGRANE_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
          }

          function drawTextAndFiligrane() {
            function afterText() {
              canvas._cleanDataUrl = canvas.toDataURL('image/jpeg', 0.95);
              drawFiligraneRaw(onDone);
            }
            if (hasText) {
              document.fonts.ready.then(function() {
                var hex = COLOR_HEX[color] || '#722F37';
                ctx.textAlign = 'center';
                ctx.globalAlpha = 1;
                ctx.font = 'bold ' + Math.round(fw * 0.062) + 'px "Balsamiq Sans", Georgia, serif';
                ctx.fillStyle = hex;
                ctx.fillText(petName, fw / 2, Math.round(textPad * 0.48));
                if (japaneseName) {
                  ctx.font = 'bold ' + Math.round(fw * 0.036) + 'px "Noto Serif JP", serif';
                  ctx.globalAlpha = 0.85;
                  ctx.fillStyle = hex;
                  ctx.fillText(japaneseName, fw / 2, Math.round(textPad * 0.86));
                  ctx.globalAlpha = 1;
                }
                afterText();
              });
            } else {
              afterText();
            }
          }

          drawTextAndFiligrane();
        };
        fondImg.onerror = function() {
          // Fallback sans fond
          var padTop = hasText ? 170 : 0;
          canvas.width  = img.width;
          canvas.height = img.height + padTop;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(dewhitened, 0, getAnimalOffset(dewhitened, img.height, padTop));
          if (onDone) onDone();
        };
        fondImg.src = NOUVEAU_FOND_URL;
        return;
      }

      // Composer d'abord le fond japonais + animal sur un canvas intermédiaire
      var fondIntermed = new Image();
      fondIntermed.crossOrigin = 'anonymous';
      fondIntermed.onload = function() {
        var fw = fondIntermed.naturalWidth;
        var fh = fondIntermed.naturalHeight;
        var intermed = document.createElement('canvas');
        intermed.width  = fw;
        intermed.height = fh;
        var ictx = intermed.getContext('2d');
        ictx.imageSmoothingEnabled = true;
        ictx.imageSmoothingQuality = 'high';

        // Centroïde + pattes
        var dwCtx2 = dewhitened.getContext('2d');
        var dwData2 = dwCtx2.getImageData(0, 0, dewhitened.width, dewhitened.height).data;
        var realBottom2 = 0, sumX2 = 0, totalAlpha2 = 0;
        for (var r = 0; r < dewhitened.height; r++) {
          for (var c = 0; c < dewhitened.width; c++) {
            var a2 = dwData2[(r * dewhitened.width + c) * 4 + 3];
            if (a2 > 10) { if (r > realBottom2) realBottom2 = r; sumX2 += c * a2; totalAlpha2 += a2; }
          }
        }
        var realCenterX2 = totalAlpha2 > 0 ? sumX2 / totalAlpha2 : dewhitened.width / 2;
        var scale2 = Math.max(fw / dewhitened.width, fh / dewhitened.height) * 0.85;
        var aw2 = Math.round(dewhitened.width * scale2);
        var ah2 = Math.round(dewhitened.height * scale2);
        var ax2 = Math.round(fw / 2 - realCenterX2 * scale2);
        var ay2 = Math.round(fh * 0.97) - Math.round(realBottom2 * scale2);

        ictx.fillStyle = '#ffffff';
        ictx.fillRect(0, 0, fw, fh);
        ictx.drawImage(fondIntermed, 0, 0, fw, fh);
        ictx.drawImage(dewhitened, ax2, ay2, aw2, ah2);

        if (hasText) {
          document.fonts.ready.then(function() {
            var hex = COLOR_HEX[color] || '#722F37';
            ictx.textAlign = 'center';
            ictx.font = 'bold ' + Math.round(fw * 0.065) + 'px "Balsamiq Sans", Georgia, serif';
            ictx.fillStyle = hex;
            ictx.fillText(petName, fw / 2, Math.round(fh * 0.075));
            if (japaneseName) {
              ictx.font = 'bold ' + Math.round(fw * 0.038) + 'px "Noto Serif JP", serif';
              ictx.globalAlpha = 0.85;
              ictx.fillStyle = hex;
              ictx.fillText(japaneseName, fw / 2, Math.round(fh * 0.13));
              ictx.globalAlpha = 1;
            }
            placeSurMockup(intermed);
          });
        } else {
          placeSurMockup(intermed);
        }
      };
      fondIntermed.onerror = function() { placeSurMockup(null); };
      fondIntermed.src = NOUVEAU_FOND_URL;

      function placeSurMockup(composedCanvas) {
        var mockup = new Image();
        mockup.crossOrigin = 'anonymous';
        mockup.onload = function() {
          var mw = mockup.naturalWidth;
          var mh = mockup.naturalHeight;
          var ts = mw / 1024;

          canvas.width  = mw;
          canvas.height = mh;
          var ctx = canvas.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, mw, mh);
          ctx.drawImage(mockup, 0, 0, mw, mh);

          var px = Math.round(mw * PRINT_X);
          var py = Math.round(mh * PRINT_Y);
          var pw = Math.round(mw * PRINT_W);
          var ph = Math.round(mh * PRINT_H);

          if (composedCanvas) {
            // Placer l'image composée dans la zone d'impression — multiply efface le fond blanc
            var fitScale = Math.min(pw / composedCanvas.width, ph / composedCanvas.height) * 1.2;
            var fw2 = Math.round(composedCanvas.width  * fitScale);
            var fh2 = Math.round(composedCanvas.height * fitScale);
            var fx  = px + Math.round((pw - fw2) / 2);
            var fy  = py + Math.round((ph - fh2) / 2);
            ctx.globalCompositeOperation = 'multiply';
            ctx.drawImage(composedCanvas, fx, fy, fw2, fh2);
            ctx.globalCompositeOperation = 'source-over';
          }

          function drawFiligrane(callback) {
            var fil = new Image();
            fil.crossOrigin = 'anonymous';
            fil.onload = function() { ctx.globalAlpha = 0.7; ctx.drawImage(fil, 0, 0, mw, mh); ctx.globalAlpha = 1; if (callback) callback(); };
            fil.onerror = function() { if (callback) callback(); };
            fil.src = FILIGRANE_URL + (FILIGRANE_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
          }
          drawFiligrane(onDone);
        };
        mockup.onerror = function() { if (onDone) onDone(); };
        mockup.src = MOCKUP_URL;
      }
      mockup.onerror = function() {
        var padTop = hasText ? 170 : 0;
        canvas.width  = img.width;
        canvas.height = img.height + padTop;
        var ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        var offsetY = getAnimalOffset(dewhitened, img.height, padTop);
        ctx.drawImage(dewhitened, 0, offsetY);
        if (onDone) onDone();
      };
      mockup.src = MOCKUP_URL;
    };
    img.src = 'data:image/png;base64,' + imageBase64;
  }

  function uploadPreviewToImgbb(imageBase64, petName, japaneseName, color, n) {
    var urlInput = document.getElementById('genurl-' + n);
    if (!urlInput) return;

    var cleanCanvas = document.createElement('canvas');
    var img = new Image();
    img.onload = function() {
      var hasText = petName && petName.length > 0;
      var padTop = hasText ? 170 : 0;
      cleanCanvas.width  = img.width;
      cleanCanvas.height = img.height + padTop;
      var ctx = cleanCanvas.getContext('2d');
      var dewhitened = removeWhite(img);

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, cleanCanvas.width, cleanCanvas.height);
      var offsetY = getAnimalOffset(dewhitened, img.height, padTop);

      function doUpload() {
        window['npp_clean_' + n] = cleanCanvas.toDataURL('image/png');
        var atcUnlocked = false;
        function unlockAtc() {
          if (atcUnlocked) return;
          atcUnlocked = true;
          showAtc();
        }
        var atcFallback = setTimeout(unlockAtc, 8000);
        cleanCanvas.toBlob(function(blob) {
          var fd = new FormData();
          fd.append('upload_preset', CLOUDINARY_PRESET);
          fd.append('file', blob, 'apercu-samourai.jpg');
          fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', { method: 'POST', body: fd })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              if (data && data.secure_url) {
                urlInput.value = data.secure_url;
                try {
                  var raw = localStorage.getItem(STORAGE_KEY + '_' + n);
                  if (raw) {
                    var stored = JSON.parse(raw);
                    stored.gelatoUrl = data.secure_url;
                    localStorage.setItem(STORAGE_KEY + '_' + n, JSON.stringify(stored));
                  }
                } catch(e) {}
              }
              clearTimeout(atcFallback);
              unlockAtc();
            })
            .catch(function() {
              clearTimeout(atcFallback);
              unlockAtc();
            });
        }, 'image/png');
      }

      var MAX_SIZE = 800;
      var iw = img.naturalWidth || 1024;
      var ih = img.naturalHeight || 1024;
      var s = Math.min(MAX_SIZE / iw, MAX_SIZE / ih, 1);
      var fw = Math.round(iw * s);
      var fh = Math.round(ih * s);
      var textPad = hasText ? Math.round(fw * 0.14) : 0;
      cleanCanvas.width  = fw;
      cleanCanvas.height = fh + textPad;
      ctx = cleanCanvas.getContext('2d');
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = 'high';
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, fw, cleanCanvas.height);
      ctx.drawImage(dewhitened, 0, Math.round(textPad * 0.5), fw, fh);

      var imgData = ctx.getImageData(0, 0, fw, cleanCanvas.height);
      var d = imgData.data;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i] >= 228 && d[i+1] >= 228 && d[i+2] >= 228) {
          d[i] = 255; d[i+1] = 255; d[i+2] = 255;
        }
      }
      ctx.putImageData(imgData, 0, 0);

      function drawTextAndUpload() {
        if (hasText) {
          document.fonts.ready.then(function() {
            var hex = COLOR_HEX[color] || '#722F37';
            ctx.textAlign = 'center';
            ctx.globalAlpha = 1;
            ctx.font = 'bold ' + Math.round(fw * 0.062) + 'px "Balsamiq Sans", Georgia, serif';
            ctx.fillStyle = hex;
            ctx.fillText(petName, fw / 2, Math.round(textPad * 0.48));
            if (japaneseName) {
              ctx.font = 'bold ' + Math.round(fw * 0.036) + 'px "Noto Serif JP", serif';
              ctx.globalAlpha = 0.85;
              ctx.fillStyle = hex;
              ctx.fillText(japaneseName, fw / 2, Math.round(textPad * 0.86));
              ctx.globalAlpha = 1;
            }
            doUpload();
          });
        } else {
          doUpload();
        }
      }
      drawTextAndUpload();
    };
    img.src = 'data:image/png;base64,' + imageBase64;
  }

  function generateMockupThumbnail(imageBase64, petName, japaneseName, color, n) {
    var img = new Image();
    img.onload = function() {
      var dewhitened = removeWhite(img);
      var SIZE = 400;
      var tc = document.createElement('canvas');
      tc.width = tc.height = SIZE;
      var ctx = tc.getContext('2d');

      function saveThumbnail() {
        try {
          var raw = localStorage.getItem(STORAGE_KEY + '_' + n);
          var stored = raw ? JSON.parse(raw) : {};
          stored.previewUrl = tc.toDataURL('image/jpeg', 0.85);
          localStorage.setItem(STORAGE_KEY + '_' + n, JSON.stringify(stored));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch(e) {}
      }

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, SIZE, SIZE);

      var mockup = new Image();
      mockup.crossOrigin = 'anonymous';
      mockup.onload = function() {
        var mw = mockup.naturalWidth, mh = mockup.naturalHeight;
        var s = Math.min(SIZE / mw, SIZE / mh);
        var mdw = Math.round(mw * s), mdh = Math.round(mh * s);
        var mdx = Math.round((SIZE - mdw) / 2), mdy = Math.round((SIZE - mdh) / 2);
        var ts = mdw / 1024;
        ctx.drawImage(mockup, mdx, mdy, mdw, mdh);

        var px = mdx + Math.round(mdw * PRINT_X);
        var py = mdy + Math.round(mdh * PRINT_Y);
        var pw = Math.round(mdw * PRINT_W);
        var ph = Math.round(mdh * PRINT_H);
        var ds = Math.min(pw / img.width, ph / img.height) * PRINT_SCALE;
        var diw = Math.round(img.width * ds), dih = Math.round(img.height * ds);
        var dix = px + Math.round((pw - diw) / 2);
        var diy = py + Math.round((ph - dih) / 2);

        function drawTextAndSave() {
          if (petName && petName.length > 0) {
            document.fonts.ready.then(function() {
              var hex = COLOR_HEX[color] || '#722F37';
              ctx.textAlign = 'center';
              ctx.globalAlpha = 1;
              ctx.font = 'bold ' + Math.round(25 * ts) + 'px "Balsamiq Sans", Georgia, serif';
              ctx.fillStyle = hex;
              var nameY = japaneseName ? diy - Math.round(20 * ts) : diy - Math.round(8 * ts);
              ctx.fillText(petName, SIZE / 2, nameY);
              if (japaneseName) {
                ctx.font = 'bold ' + Math.round(16 * ts) + 'px "Noto Serif JP", serif';
                ctx.globalAlpha = 0.85;
                ctx.fillStyle = hex;
                ctx.fillText(japaneseName, SIZE / 2, diy + Math.round(5 * ts));
                ctx.globalAlpha = 1;
              }
              saveThumbnail();
            });
          } else {
            saveThumbnail();
          }
        }

        var platform = new Image();
        platform.crossOrigin = 'anonymous';
        platform.onload = function() {
          ctx.globalCompositeOperation = 'multiply';
          ctx.drawImage(platform, dix, diy, diw, dih);
          ctx.globalCompositeOperation = 'source-over';
          ctx.drawImage(dewhitened, dix, diy, diw, dih);
          drawTextAndSave();
        };
        platform.onerror = function() {
          ctx.drawImage(dewhitened, dix, diy, diw, dih);
          drawTextAndSave();
        };
        platform.src = PLATFORM_URL + (PLATFORM_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
      };
      mockup.onerror = saveThumbnail;
      mockup.src = MOCKUP_URL + (MOCKUP_URL.indexOf('?') >= 0 ? '&' : '?') + 'cb=1';
    };
    img.src = 'data:image/png;base64,' + imageBase64;
  }

  var STORAGE_KEY = 'npp_samourai_design';
  var EXPIRY_MS = 3 * 60 * 60 * 1000;
  var timerIntervals = {};
  var OFFER_EXPIRY_MS = 3 * 60 * 60 * 1000;
  var OFFER_STORAGE_KEY = 'npp_mystery_offer';
  var offerTimerIntervals = {};
  var originalPriceState = null;

  function saveDesign(dataUrl, petName, japaneseName, color, n, cleanDataUrl) {
    try {
      localStorage.setItem(STORAGE_KEY + '_' + n, JSON.stringify({
        dataUrl: dataUrl, cleanDataUrl: cleanDataUrl || null,
        petName: petName, japaneseName: japaneseName,
        color: color, expiry: Date.now() + EXPIRY_MS
      }));
    } catch(e) {}
  }

  function loadSavedDesign(n) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY + '_' + n);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data.expiry) {
        data.expiry = Date.now() + EXPIRY_MS;
        localStorage.setItem(STORAGE_KEY + '_' + n, JSON.stringify(data));
      }
      if (Date.now() > data.expiry) {
        localStorage.removeItem(STORAGE_KEY + '_' + n);
        return null;
      }
      return data;
    } catch(e) { return null; }
  }

  function startTimer(expiryTs, n) {
    if (timerIntervals[n]) clearInterval(timerIntervals[n]);
    var timerDiv = document.querySelector('#genresult-' + n + ' .perso__gen-timer');
    if (timerDiv) timerDiv.innerHTML = 'Votre création expire dans <span id="gencount-' + n + '">--</span>';
    function update() {
      var remaining = expiryTs - Date.now();
      var text;
      if (remaining <= 0) {
        clearInterval(timerIntervals[n]);
        localStorage.removeItem(STORAGE_KEY + '_' + n);
        text = 'expiré';
        var countEl = document.getElementById('gencount-' + n);
        if (countEl) countEl.textContent = text;
        if (n === 1) { var t = document.getElementById('npp-top-count'); if (t) t.textContent = text; }
        return;
      }
      var h = Math.floor(remaining / 3600000);
      var m = Math.floor((remaining % 3600000) / 60000);
      var s = Math.floor((remaining % 60000) / 1000);
      text = h + 'h' + (m < 10 ? '0' : '') + m + 'm' + (s < 10 ? '0' : '') + s + 's';
      var countEl = document.getElementById('gencount-' + n);
      if (countEl) countEl.textContent = text;
      if (n === 1) { var t = document.getElementById('npp-top-count'); if (t) t.textContent = text; }
    }
    update();
    timerIntervals[n] = setInterval(update, 1000);
  }

  function captureOriginalPriceState() {
    var pl = document.querySelector('price-list');
    if (!pl) return;
    var sale = pl.querySelector('sale-price');
    var cmp = pl.querySelector('compare-at-price');
    var bl = document.querySelector('badge-list');
    var badge = pl.querySelector('on-sale-badge') || document.querySelector('.badge--on-sale');
    originalPriceState = {
      saleHTML: sale ? sale.innerHTML : null,
      cmpHTML: cmp ? cmp.innerHTML : null,
      cmpHidden: cmp ? cmp.hasAttribute('hidden') : true,
      blHidden: bl ? bl.hasAttribute('hidden') : true,
      badgeHTML: badge ? badge.innerHTML : null,
      badgeHidden: badge ? badge.hasAttribute('hidden') : true
    };
  }

  function restoreOriginalPriceState() {
    if (!originalPriceState) return;
    var pl = document.querySelector('price-list');
    if (!pl) return;
    var sale = pl.querySelector('sale-price');
    if (sale && originalPriceState.saleHTML !== null) sale.innerHTML = originalPriceState.saleHTML;
    var cmp = pl.querySelector('compare-at-price');
    if (cmp) {
      if (originalPriceState.cmpHTML !== null) cmp.innerHTML = originalPriceState.cmpHTML;
      if (originalPriceState.cmpHidden) cmp.setAttribute('hidden', ''); else cmp.removeAttribute('hidden');
    }
    var bl = document.querySelector('badge-list');
    if (bl) { if (originalPriceState.blHidden) bl.setAttribute('hidden', ''); else bl.removeAttribute('hidden'); }
    var badge = pl.querySelector('on-sale-badge') || document.querySelector('.badge--on-sale');
    if (badge) {
      if (originalPriceState.badgeHTML !== null) badge.innerHTML = originalPriceState.badgeHTML;
      if (originalPriceState.badgeHidden) badge.setAttribute('hidden', ''); else badge.removeAttribute('hidden');
    }
  }

  function setPriceText(el, text) {
    if (!el) return;
    var nodes = el.childNodes;
    for (var i = nodes.length - 1; i >= 0; i--) {
      if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) { nodes[i].textContent = text; return; }
    }
    el.appendChild(document.createTextNode(text));
  }

  function hidePriceDiscount() {
    var pl = document.querySelector('price-list');
    if (!pl) return;
    var sale = pl.querySelector('sale-price');
    if (sale) { sale.removeAttribute('hidden'); sale.style.color = ''; sale.style.fontSize = ''; sale.style.fontWeight = ''; sale.style.letterSpacing = ''; }
    var cmp = pl.querySelector('compare-at-price');
    if (cmp) cmp.setAttribute('hidden', '');
  }

  function saveOffer() {
    try { localStorage.setItem(OFFER_STORAGE_KEY, JSON.stringify({ expiry: Date.now() + OFFER_EXPIRY_MS })); } catch(e) {}
  }

  function loadOffer() {
    try {
      var raw = localStorage.getItem(OFFER_STORAGE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      if (Date.now() > d.expiry) { localStorage.removeItem(OFFER_STORAGE_KEY); return null; }
      return d;
    } catch(e) { return null; }
  }

  function activateMysteryOffer(n) {
    // Désactivé — laisse uniquement le timer
  }

  function deactivateMysteryOffer(n) {
    localStorage.removeItem(OFFER_STORAGE_KEY);
    if (offerTimerIntervals[n]) { clearInterval(offerTimerIntervals[n]); delete offerTimerIntervals[n]; }
    var announce = document.getElementById('npp-offer-line-' + n);
    if (announce) announce.remove();
    var topAlert = document.getElementById('npp-top-alert');
    if (topAlert) topAlert.remove();
  }

  function startOfferTimer(expiryTs, n) {
    if (offerTimerIntervals[n]) clearInterval(offerTimerIntervals[n]);
    function tick() {
      var rem = expiryTs - Date.now();
      if (rem <= 0) { clearInterval(offerTimerIntervals[n]); deactivateMysteryOffer(n); return; }
      var h = Math.floor(rem / 3600000);
      var m = Math.floor((rem % 3600000) / 60000);
      var s = Math.floor((rem % 60000) / 1000);
      var txt = h + 'h' + (m < 10 ? '0' : '') + m + 'm' + (s < 10 ? '0' : '') + s + 's';
      var el = document.getElementById('offcount-' + n);
      if (el) el.textContent = txt;
      var topEl = document.getElementById('npp-top-offcount');
      if (topEl) topEl.textContent = txt;
    }
    tick();
    offerTimerIntervals[n] = setInterval(tick, 1000);
  }

  function updateTopAlertOffer(n) {
    var alertEl = document.getElementById('npp-top-alert');
    if (!alertEl || document.getElementById('npp-top-offer')) return;
    var span = document.createElement('span');
    span.id = 'npp-top-offer';
    span.style.cssText = 'color:#ffe8c0;font-weight:700;margin-left:0.4rem;white-space:nowrap;';
    span.innerHTML = '· 🎉 Mystery Offer: <span id="npp-top-offcount">--</span>';
    var btn = document.getElementById('npp-top-btn');
    if (btn) alertEl.insertBefore(span, btn); else alertEl.appendChild(span);
  }

  function showMysteryPopup() {
    if (document.getElementById('npp-mystery-popup')) return;
    var p = document.createElement('div');
    p.id = 'npp-mystery-popup';
    p.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%) translateY(20px);opacity:0;background:linear-gradient(135deg,#c45b78,#9b6aaa);color:#fff;padding:1.1rem 1.8rem;border-radius:14px;box-shadow:0 8px 32px rgba(0,0,0,0.28);z-index:9999;text-align:center;max-width:92vw;transition:opacity 0.4s,transform 0.4s;line-height:1.5;';
    p.innerHTML = '🎉 <strong>Offre Mystère débloquée !</strong><br>'
      + '<span style="font-size:1.4rem;font-weight:800;">£24.90</span> '
      + '<span style="text-decoration:line-through;opacity:0.7;font-size:1rem;">£39.90</span><br>'
      + '<span style="font-size:0.8rem;opacity:0.9;">Offre valable 3h — profites-en !</span>';
    document.body.appendChild(p);
    requestAnimationFrame(function() { p.style.transform = 'translateX(-50%) translateY(0)'; p.style.opacity = '1'; });
    setTimeout(function() {
      p.style.opacity = '0'; p.style.transform = 'translateX(-50%) translateY(20px)';
      setTimeout(function() { if (p.parentNode) p.parentNode.removeChild(p); }, 500);
    }, 5000);
  }

  function showTopAlert(saved) {
    if (document.getElementById('npp-top-alert')) return;
    var alert = document.createElement('div');
    alert.id = 'npp-top-alert';
    alert.style.cssText = 'background:linear-gradient(135deg,#c45b78,#9b6aaa);border:none;padding:0.6rem 1rem;display:flex;align-items:center;justify-content:center;gap:0.5rem;font-size:0.8rem;font-weight:600;color:#fff;flex-wrap:wrap;text-align:center;';
    alert.innerHTML = 'Votre création expire dans <span id="npp-top-count" style="color:#ffe8c0;font-weight:800;margin:0 0.08rem;font-size:0.95rem;">--</span>'
      + '<a href="#genresult-1" id="npp-top-btn" style="background:rgba(255,255,255,0.25);color:#fff;border-radius:99px;padding:0.25em 0.9em;font-size:0.78rem;font-weight:700;text-decoration:none;margin-left:0.4rem;white-space:nowrap;border:1.5px solid rgba(255,255,255,0.5);">Voir mon design</a>';
    var annBar = document.querySelector('#shopify-section-announcement-bar, .announcement-bar, [class*="announcement"]');
    if (annBar) {
      annBar.insertAdjacentElement('afterend', alert);
    } else {
      var header = document.querySelector('header, #header');
      if (header) header.insertAdjacentElement('afterend', alert);
      else document.body.insertAdjacentElement('afterbegin', alert);
    }
    document.getElementById('npp-top-btn').addEventListener('click', function(e) {
      e.preventDefault();
      var target = document.getElementById('genresult-1');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function finishBlock(n) {
    var formSection = document.getElementById('perso-form-' + n);
    if (formSection) formSection.style.display = 'none';
    var blockDel = document.getElementById('blockdel-' + n);
    if (blockDel) blockDel.style.display = 'none';
    var genBtnFinish = document.getElementById('genbtn-' + n);
    if (genBtnFinish) genBtnFinish.style.display = 'none';
    updateAddBtn();
  }

  function updateAddBtn() {
    var addBtn = document.getElementById('perso-add-btn');
    var allBlocks = container.querySelectorAll('.perso');
    var generatedCount = 0;
    allBlocks.forEach(function(block, i) {
      var form = document.getElementById('perso-form-' + (i + 1));
      if (form && form.style.display === 'none') generatedCount++;
    });
    var shouldShow = generatedCount > 0 && generatedCount === allBlocks.length && blockCount < 3;
    if (shouldShow) {
      if (!addBtn) {
        addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.id = 'perso-add-btn';
        addBtn.className = 'perso__add-btn';
        addBtn.textContent = '＋ Créer un autre design';
        addBtn.addEventListener('click', addDesignBlock);
      }
      container.appendChild(addBtn);
      addBtn.style.display = '';
    } else if (addBtn) {
      addBtn.style.display = 'none';
    }
  }

  function addDesignBlock() {
    var newN = blockCount + 1;
    if (newN > 3) return;
    blockCount = newN;
    var block = createBlock(newN - 1, newN);
    bindAccordion(block, newN);
    bindPreview(block, newN);
    container.appendChild(block);
    updateAddBtn();
    block.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderBlocks(qty) {
    var currentBlocks = container.querySelectorAll('.perso');
    var currentQty = currentBlocks.length;

    if (currentQty === 0) {
      blockCount = qty;
      uploadPending = 0;
      previewGenerated = false;
      hideAtc();
      for (var i = 0; i < qty; i++) {
        var block = createBlock(i, qty);
        bindAccordion(block, i + 1);
        bindPreview(block, i + 1);
        container.appendChild(block);
      }
      return;
    }

    if (qty === currentQty) return;

    if (qty > currentQty) {
      blockCount = qty;
      for (var i = currentQty; i < qty; i++) {
        var block = createBlock(i, qty);
        bindAccordion(block, i + 1);
        bindPreview(block, i + 1);
        container.appendChild(block);
      }
    } else {
      blockCount = qty;
      var persoBlocks = container.querySelectorAll('.perso');
      for (var i = persoBlocks.length - 1; i >= qty; i--) {
        container.removeChild(persoBlocks[i]);
      }
    }

    updateAddBtn();
  }

  function restoreBlock(n, saved) {
    if (!document.getElementById('gencanvas-' + n)) {
      for (var i = blockCount; i < n; i++) {
        var b = createBlock(i, n);
        bindAccordion(b, i + 1);
        bindPreview(b, i + 1);
        container.appendChild(b);
        blockCount = i + 1;
      }
    }
    var canvas  = document.getElementById('gencanvas-' + n);
    var resultEl = document.getElementById('genresult-' + n);
    if (!canvas || !resultEl) return;
    var img = new Image();
    img.onload = function() {
      canvas.width  = img.width;
      canvas.height = img.height;
      if (!USE_MOCKUP) canvas.style.marginTop = '0';
      canvas.getContext('2d').drawImage(img, 0, 0);
      var nameInput = document.getElementById('pn-' + n);
      if (nameInput && saved.petName) nameInput.value = saved.petName;
      var photoVal = document.getElementById('pv-' + n);
      if (photoVal) photoVal.value = 'design_sauvegarde';
      document.querySelectorAll('input[name="properties[T-shirt ' + n + ' - Kimono color]"]').forEach(function(radio) {
        if (radio.value === saved.color) { radio.checked = true; radio.dispatchEvent(new Event('change')); }
      });
      var urlInput = document.getElementById('genurl-' + n);
      if (urlInput && saved.gelatoUrl) urlInput.value = saved.gelatoUrl;
      resultEl.style.display = 'block';
      previewGenerated = true;
      showAtc();
      finishBlock(n);
      if (n === 1) showTopAlert(saved);
      startTimer(saved.expiry, n);
      activateMysteryOffer(n);

    };
    img.src = saved.dataUrl;
  }

  function restoreSavedDesign() {
    var maxRestored = 0;
    for (var n = 1; n <= 3; n++) {
      var saved = loadSavedDesign(n);
      if (saved) { restoreBlock(n, saved); maxRestored = n; }
    }
  }

  renderBlocks(1);
  window.persoUpdateQty = renderBlocks;
  window.addEventListener('load', function() {
    restoreSavedDesign();
  });
})();
